module.exports = __webpack_public_path__ + "static/img/3_5_2.f5b3eb1e.jpg";